// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1ARvA","content":"LayoutSettings_content__2jOPg"};